module.exports = __webpack_public_path__ + "img/github.40e0e70d.svg";